module.exports = __webpack_public_path__ + "img/mike.5ad98c64.jpg";